(function () {
  var path = window.location.pathname.replace(/\/$/, '');
  var match = path.match(/\/products\/([^/]+)/);
  if (!match) return;

  var handle = match[1];
  var map = {
    'isabelle-bag-earth': 'earth',
    'isabelle-bag-meadow': 'meadow',
    'isabelle-bag-sky': 'sky',
    'isa-everyday-bag-earth': 'earth',
    'isa-everyday-bag-tan': 'earth',
    'isa-everyday-bag-latte': 'earth',
    'isa-everyday-bag-meadow': 'meadow',
    'isa-everyday-bag-matcha': 'meadow',
    'isa-tote-bag-matcha': 'meadow',
    'isa-everyday-bag-sky': 'sky',
    'isa-everyday-bag-aqua': 'sky',
    'sample-tiffany-tote': 'sky',
  };
  var colourway = map[handle];
  if (!colourway) return;

  document.querySelectorAll('.laau-colourway-pill').forEach(function (pill) {
    var active = pill.getAttribute('data-colourway') === colourway;
    pill.classList.toggle('is-active', active);
    if (active) pill.setAttribute('aria-current', 'page');
    else pill.removeAttribute('aria-current');
  });
})();
